import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Link } from '@tanstack/react-router';
import { MdClose } from 'react-icons/md';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const LINKS = [
  {
    title: '手動で作成',
    description: '空のフォームに手動で\n入力して作成します。',
    link: '/agent/companies/new',
    icon: 'manual',
  },
  {
    title: '外部サービスから取り込み',
    description: '外部サービスと連携して\n複数企業を取り込みます。',
    link: '/agent/linked_accounts',
    icon: 'ats',
  },
];

export default function CompaniesAddModal({ isOpen, onClose }: Props) {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onClose();
      }}
    >
      <DialogContent className="h-[550px] w-[850px] overflow-hidden rounded-[24px] px-[143px] py-[87px] shadow-[0px_0px_24px_0px_rgba(0,_0,_0,_0.20)]!">
        <img src="/agent/modal-decorate-bottom.svg" alt="" className="absolute bottom-0 left-0" />
        <img src="/agent/modal-decorate-top.svg" alt="" className="absolute top-0 right-0" />
        <button
          onClick={onClose}
          className="absolute top-[36px] right-[46px] z-10 rounded-full bg-white p-2 hover:opacity-60"
          aria-label="閉じる"
        >
          <MdClose size={24} color="#818B9A" />
        </button>
        {/* コンテンツ */}
        <div className="relative z-10">
          <div className="flex flex-col items-center justify-center gap-sm">
            <DialogTitle asChild>
              <p className="text-3xl! font-bold!">企業を登録</p>
            </DialogTitle>
            <p className="text-base">企業を登録します。登録方法を選択してください。</p>
          </div>
          <div className="mt-x3l flex gap-6">
            {LINKS.map((l, key) => {
              return (
                <Link
                  to={l.link}
                  className="flex h-[250px] flex-1 flex-col items-center justify-center gap-md rounded-md bg-white p-md shadow-layer1"
                  key={key}
                >
                  <img src={`/agent/companies/add-${l.icon}.svg`} width={100} height={100} alt="" />
                  <div className="flex flex-col items-center justify-center gap-2">
                    <p className="text-lg font-bold">{l.title}</p>
                    <p className="text-xs leading-[170%] whitespace-pre-wrap text-sub">
                      {l.description}
                    </p>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
